import React from "react";
import NotesFacilitatorViewModal from "./NotesFacilitatorViewModal";
import ReactTable from "react-table";
import { Button } from "../../../common/Button/Button";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";

import moment from "moment";

export default function FacilitatorActionsTable(props) {
	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};
	const columns = [
		{
			id: "customerDetails",
			Header: "Customer Details",
			accessor: "customerDetails",
			width: 170,
			Cell: ({ original }) => {
				return original["refService"] ? (
					<>
						<span>{original["refService"]["sEmailAddress"]}</span>
						<br></br>
						<span>
							{original["refService"]["sFirstName"]}{" "}
							{original["refService"]["sLastName"]}
						</span>
						<br></br>
						{original["refService"]["sEmailAddress"] ? (
							<span>
								{original["refService"]["sContactNumber"]}
							</span>
						) : (
							""
						)}
						<br></br>
						{original["refService"]["sEmailAddress"] ? (
							<a
								href={`${
									original["refService"]["sEmailAddress"]
										? `/home/three-sixty-degree-view?email=${original["refService"]["sEmailAddress"]}`
										: `/home/three-sixty-degree-view`
								}  `}
								target="_blank"
							>
								360 View
							</a>
						) : (
							""
						)}
					</>
				) : (
					<span>{"-"}</span>
				);
			},
		},
		{
			id: "bHandled",
			Header: "Completed",
			accessor: "bHandled",
			width: 170,
			Cell: ({ original }) => {
				return original["bHandled"] ? (
					<span>Yes</span>
				) : (
					<span>No</span>
				);
			},
		},
		{
			id: "sFollowupAction",
			Header: "Followup Action",
			accessor: "sFollowupAction",
			width: 170,
			Cell: ({ original }) => {
				return original["sFollowupAction"] ? (
					<span>{original["sFollowupAction"]}</span>
				) : (
					<span>-</span>
				);
			},
		},
		{
			id: "sNotes",
			Header: "Note",
			accessor: "sNotes",
			width: 170,
			Cell: ({ original }) => {
				return original["sNotes"] ? (
					<span>{original["sNotes"]}</span>
				) : (
					<span>-</span>
				);
			},
		},

		{
			id: "dtUpdatedOn",
			Header: "Updated On",
			accessor: "dtUpdatedOn",
			width: 170,
			Cell: ({ original }) => {
				return original["dtUpdated"] ? (
					<span>
						{moment(
							moment.utc(original["dtUpdated"]).toDate()
						).format("MMMM Do YYYY, h:mm:ss a")}
					</span>
				) : (
					<span>-</span>
				);
			},
		},
		{
			id: "dtCreatedOn",
			Header: "Created On",
			accessor: "dtCreatedOn",
			width: 170,
			Cell: ({ original }) => {
				return original["dtCreated"] ? (
					<span>
						{moment(
							moment.utc(original["dtCreated"]).toDate()
						).format("MMMM Do YYYY, h:mm:ss a")}
					</span>
				) : (
					<span>-</span>
				);
			},
		},
		{
			id: "dtFollowupOn",
			Header: "Followup On",
			accessor: "dtFollowupOn",
			width: 170,
			Cell: ({ original }) => {
				return original["dtFollowupOn"] ? (
					<span>
						{moment(
							moment.utc(original["dtFollowupOn"]).toDate()
						).format("MMMM Do YYYY, h:mm:ss a")}
					</span>
				) : (
					<span>-</span>
				);
			},
		},

		{
			id: "refCreatedBy",
			Header: "Created By",
			accessor: "refCreatedBy",
			width: 170,
			Cell: ({ original }) => {
				return original["refCreatedBy"] ? (
					<span>{original["refCreatedBy"]["email"]}</span>
				) : (
					<span>{"-"}</span>
				);
			},
		},
		{
			id: "refUpdatedBy",
			Header: "Updated By",
			accessor: "refUpdatedBy",
			width: 170,
			Cell: ({ original }) => {
				return original["refUpdatedBy"] ? (
					<span>{original["refUpdatedBy"]["email"]}</span>
				) : (
					<span>{"-"}</span>
				);
			},
		},

		{
			id: "serviceDetails",
			Header: "Service Details",
			accessor: "serviceDetails",
			width: 170,
			Cell: ({ original }) => {
				return original["refService"] ? (
					<>
						<span>{getServiceName(original["refService"])}</span>
						<br></br>
						<span>
							{original["refService"]["nResourceInstanceId"]}
						</span>
					</>
				) : (
					<span>{"-"}</span>
				);
			},
		},
		{
			id: "editNote",
			Header: "Edit Note",
			accessor: "editNote",
			width: 170,
			Cell: ({ original }) => {
				return (
					<button
						className="notes-button"
						onClick={() => {
							props.onSelectFacilitatorAction(original);
							props.toggleNotesModal();
						}}
					>
						Edit Note
					</button>
				);
			},
		},
	];
	const NoDataComponent = (p) => {
		return <div>No data</div>;
	};
	return (
		<>
			<ReactTable
				data={props.data || []}
				columns={columns}
				manual
				pages={props.pages}
				page={props.page}
				pageSize={props.pageSize}
				NoDataComponent={NoDataComponent}
				showPageSizeOptions={false}
				style={{
					overflowY: "auto",
					height: "800px"}}
				onFetchData={(state, instance) => {
					props.onFetchServiceRequests(instance, true);
					// if (props.page === 0) instance.state.page = 0;
				}}
				NextComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Next
					</Button>
				)}
				PreviousComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Previous
					</Button>
				)}
			/>

			<NotesFacilitatorViewModal
				// auditTrail={props.auditTrail} //
				// changeSelectedNotesDetails={props.changeSelectedNotesDetails} //
				// notesHistory={props.notesHistory} //
				facilitatorActionView={props.facilitatorActionView}
				notesDetails={props.selectedFacilitatorAction}
				isOpen={props.showNotesModal}
				toggleModal={props.toggleNotesModal}
				onInputChange={props.onNotesChange}
				onSaveNotesDetails={props.onSaveSelectedFacilitatorAction}
				isOpenConfirmationModal={props.showConfirmationModalNotes}
				toggleConfirmationModal={props.toggleConfirmationModalNotes}
				confirmChangeNotes={props.confirmChangeNotes}
			/>
		</>
	);
}
